module.exports = __webpack_public_path__ + "static/img/huasheng.43df8317.png";